/* eslint-disable import/no-cycle */
import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import useQueryData from './use-query-data';
import { useMicrosite } from '../../../contexts/franchise/microsite-context';

export type LinkProps = {
    to: string,
    onClick?:(event: React.MouseEvent<HTMLAnchorElement>) => void,
    children?: string | React.ReactNode | React.ReactNode[]
    className?: string
    style?: React.CSSProperties
} & React.HTMLProps<HTMLAnchorElement>;

const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(({
    to, children, onClick, ref: _, ...props
}, ref) => {
    const { permalink, isMicrosite } = useMicrosite();
    const [path, queryString, hash] = useQueryData(to);

    const linkIsExternal = path.includes(':');

    if (linkIsExternal) {
        return (
            <a
                ref={ref}
                href={to}
                rel="noreferrer noopener"
                target="_blank"
                {...props}
            >
                {children}
            </a>
        );
    }

    const pathPrefix = (() => {
        if (permalink && isMicrosite && path.startsWith('/') && !path.startsWith('/locations')) {
            return permalink;
        }
        return '';
    })();

    return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
        <GatsbyLink
            ref={ref}
            to={`${pathPrefix}${path.replace(pathPrefix, '')}${queryString}${hash}`}
            onClick={(e) => {
                if (hash) {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    window.gatsby_router_hash = hash;
                }
                if (onClick) {
                    onClick(e);
                }
            }}
            {...props}
        >
            {children}
        </GatsbyLink>
    );
});

Link.displayName = 'Link';

export default Link;
